import React from 'react';
import cn from 'classnames';
import ReactDatepicker from 'react-datepicker';
import PortalWrp from '@framework/ui/Templates/PortalWrp';
import { TIME_FORMAT_WITH_SECONDS } from '@creditflowresearch/uilib/utils/dateFormats';
import CustomTimeInput from './CustomTimeInput';

import styles from './timePicker.module.scss';

type Field = 'min' | 'max';

interface ITimePicker {
  customInput: React.ReactNode,
  dateFormat?: string,
  usePortal: boolean,
  placeholderText: string,
  selected: Date,
  popperPlacement: string,
  datePickerRef?: React.LegacyRef<ReactDatepicker>,
  dataTest: string,
  name: Field,
  increment: (value: number, name: Field) => void,
  decrement: (value: number, name: Field) => void,
  onChange: (value: string, name: Field) => void,
  onChangeCustomTimeInput: (value: string, name: Field) => void,
}

function TimePicker({ increment, decrement, onChangeCustomTimeInput, onChange, name, ...props }: ITimePicker) {
  let { dateFormat = TIME_FORMAT_WITH_SECONDS, datePickerRef, dataTest } = props;
  const onIncrement = (value) => increment(value, name);
  const onDecrement = (value) => decrement(value, name);
  const onChangePicker = (value) => onChange(value, name);
  const onChangeInput = (value) => onChangeCustomTimeInput(value, name);

  return (
    <ReactDatepicker
      ref={ datePickerRef }
      dateFormat={ dateFormat }
      // @ts-ignore
      popperPlacement="bottom-end"
      className={ styles.reactDatepicker }
      popperContainer={ props.usePortal ? PortalWrp : null }
      popperClassName={ cn(styles.pickerPopper, styles.timePicker) }
      showTimeInput
      showTimeSelectOnly
      data-test={ dataTest }
      onChange={ onChangePicker }
      customTimeInput={ (
        <CustomTimeInput
          increment={ onIncrement }
          decrement={ onDecrement }
          onChangeInput={ onChangeInput }
        />
      ) }
      { ...props }
    />
  );
}

export default TimePicker;
